import React from 'react';
import { Link } from 'react-router-dom';
import useLang from '../../i18n/useLang';
import logo from '../../images/logotrasnparent.png';

const LINKEDIN = 'https://www.linkedin.com/company/grovv-systems/';

function Column({ title, children }) {
  return (
    <div>
      <h2 className="mb-4 text-sm font-semibold text-white">{title}</h2>
      <ul className="space-y-1 text-[0.95rem]">{children}</ul>
    </div>
  );
}

function Item({ to, href, children }) {
  const cls = 'inline-flex min-h-[44px] items-center text-navy-300 transition-colors hover:text-white';
  return <li>{href ? <a href={href} className={cls}>{children}</a> : <Link to={to} className={cls}>{children}</Link>}</li>;
}

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-navy-950 text-navy-300">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 start-1/2 h-80 w-[48rem] -translate-x-1/2 rounded-full bg-grovv/10 blur-3xl rtl:translate-x-1/2"
      />
      <div className="wrap relative grid grid-cols-1 gap-12 py-16 sm:grid-cols-3 sm:py-20 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div className="max-w-sm sm:col-span-3 lg:col-span-1">
          <img src={logo} alt="Grovv" width="92" height="36" className="h-9 w-auto brightness-0 invert" />
          <p className="mt-5 text-[0.95rem] leading-relaxed">{t('site.footer.tagline')}</p>
          <p className="mt-5 text-[0.95rem]">{t('site.footer.address')}</p>
        </div>
        <Column title={t('site.footer.company')}>
          <Item to="/aboutGrovv">{t('header.About')}</Item>
          <Item to="/Customers">{t('header.Costumers')}</Item>
        </Column>
        <Column title={t('site.footer.services')}>
          <Item to="/services">{t('header.Services')}</Item>
          <Item to="/Competence">{t('header.Competence')}</Item>
        </Column>
        <Column title={t('site.footer.resources')}>
          <Item to="/Blog">{t('header.Blog')}</Item>
          <Item to="/contact">{t('header.Contact')}</Item>
          <Item href={LINKEDIN}>{t('site.footer.linkedin')}</Item>
        </Column>
      </div>
      <div className="wrap relative flex flex-wrap items-center justify-between gap-4 border-t border-white/10 py-6 text-sm">
        <span className="tabular-nums">
          © {year} {t('site.footer.rights')}
        </span>
        <a href={LINKEDIN} aria-label="Grovv on LinkedIn" className="inline-flex h-10 w-10 items-center justify-center rounded-full text-navy-300 ring-1 ring-inset ring-white/15 transition-colors hover:bg-white/10 hover:text-white">
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9.75h4v11H3v-11zm6.5 0h3.8v1.5h.06c.53-.95 1.83-1.95 3.77-1.95 4.03 0 4.77 2.55 4.77 5.86v5.59h-4v-4.96c0-1.18-.02-2.7-1.7-2.7-1.7 0-1.96 1.28-1.96 2.61v5.05h-4v-11z" />
          </svg>
        </a>
      </div>
    </footer>
  );
}
